"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Card_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/Card.vue"));
const CounterBlock_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/CounterBlock.vue"));
const DistributorsList_vue_1 = __importDefault(require("@becrop/components/Profile/Access/components/DistributorsList.vue"));
const AccessData_1 = __importDefault(require("@becrop/components/Profile/Access/class/models/AccessData"));
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let CountCards = class CountCards extends vue_property_decorator_1.Vue {
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: new AccessData_1.default() })
], CountCards.prototype, "dataSet", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CountCards.prototype, "client", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], CountCards.prototype, "dimension", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], CountCards.prototype, "isLoadingView", void 0);
CountCards = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Card: Card_vue_1.default,
            CounterBlock: CounterBlock_vue_1.default,
            DistributorsList: DistributorsList_vue_1.default,
            LoaderInline: bmk_ui_framework_1.LoaderInline,
        },
    })
], CountCards);
exports.default = CountCards;
